const HEX_COLOR_RE = /^#[0-9a-fA-F]{6}$/;

export function sanitizeColor(value: string, fallback = ""): string {
	return HEX_COLOR_RE.test(value) ? value : fallback;
}
